import React, { useEffect, useState, useMemo, useCallback } from "react"
import FloatingBanner from "./floating_banner"
import Cookies from "universal-cookie"

export const ConsentForm = () => {
    const [decisionMade, setDecisionMade] = useState(true) // start with true to avoid flashing
    const cookies = useMemo(() => new Cookies(), []);

    function gtag() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
    }

    const sendConsent = useCallback((consent) => {
        gtag('consent', 'default', consent);
    }, []);

    useEffect(() => {
        if (cookies.get("cookies_consent") !== undefined) {
            setDecisionMade(true)
        } else {
            setDecisionMade(false)
        }
    }, [cookies, setDecisionMade, sendConsent])

    const handleDecision = (outcome) => {
        const consent = {
            'ad_storage': outcome,
            'analytics_storage': 'granted',
            'ad_user_data': outcome,
            'ad_personalization': outcome,
        }

        const expDate = new Date()
        if (outcome === "denied") {
            expDate.setMonth(expDate.getMonth() + 3)
        } else {
            expDate.setFullYear(expDate.getFullYear() + 5)
        }

        cookies.set("cookies_consent", consent, {
            expires: expDate,
            path: "/",
            domain: ".cloud66.com"
        })

        sendConsent(consent)
        setDecisionMade(true)
    }

    return (
        decisionMade ? (
            <></>
        ) : (
            <FloatingBanner
                color="blue"
                header="Pardon the interruption, but we have to do this."
                message="Cloud 66 uses cookies to make our site work and also for analytics and advertising purposes. You can learn more about how we use cookies in our Privacy Policy."
                acceptText="OK"
                onAccept={
                    () => {
                        handleDecision("granted")
                    }
                }
            />
        )
    )
}